import React from 'react';
import { motion } from 'framer-motion';

const Header: React.FC = () => {
  return (
    <motion.header 
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="bg-[#3783FE] py-4 px-6 fixed w-full top-0 z-50 backdrop-blur-sm"
    >
      <div className="container mx-auto flex justify-between items-center">
        <motion.a 
          href="#"
          onClick={(e) => {
            e.preventDefault();
            window.location.hash = '';
            window.location.reload();
          }}
          whileHover={{ scale: 1.05 }}
          className="flex items-center cursor-pointer"
        >
          <img 
            src="/assets/logo.png" 
            alt="Koral Convergence" 
            className="h-16 w-auto object-contain"
          />
        </motion.a>
        
      </div>
    </motion.header>
  );
};

export default Header;
